/**
 * Triggers the Fly-to-Cart animation from a click event or HTMLElement to the header cart icon.
 * Explicitly restricted to the coffee/cafe industry theme.
 * @param {Event|HTMLElement|Object} origin - Click event, ref, or HTMLElement
 * @param {string} [imageUrl] - Optional product image URL to animate
 */
export function flyToCart(origin, imageUrl) {
  let startRect = null;

  if (origin) {
    if (origin instanceof HTMLElement) {
      startRect = origin.getBoundingClientRect();
    } else if (origin.currentTarget instanceof HTMLElement) {
      startRect = origin.currentTarget.getBoundingClientRect();
    } else if (origin.target instanceof HTMLElement) {
      startRect = origin.target.getBoundingClientRect();
    }
  }

  window.dispatchEvent(
    new CustomEvent('fly-to-cart', {
      detail: {
        startRect,
        imageUrl,
      },
    }),
  );
}
